/////////////////////////////////////////////////////////////////////////////
// Renders text in title case, handling arrays and null/undefined values.
// Supports optional regex replacement before formatting.
// Usage examples:
// <RenderTitleCase text="hello world" /> -> "Hello World"
// <RenderTitleCase text={["hello", null, "world"]} joinWith=", " /> -> "Hello, World"
// <RenderTitleCase text="COMPLETE_STATUS" replacePattern={/_/g} /> -> "Complete Status"
// <RenderTitleCase text="FOO_BAR_BAZ" replacePattern={/_/g} replaceValue="-" /> -> "Foo-Bar-Baz"
/////////////////////////////////////////////////////////////////////////////

import { useTranslation } from "react-i18next";
import { titleCase } from "title-case";

interface RenderTitleCaseProps {
  text: string | (string | undefined | null)[];
  joinWith?: string;
  emptyValue?: string | null;
  replacePattern?: RegExp;
  replaceValue?: string;
}

export const RenderTitleCase: React.FC<RenderTitleCaseProps> = ({
  text,
  joinWith = " ",
  emptyValue = "",
  replacePattern,
  replaceValue = " ",
}) => {
  const { t } = useTranslation();

  if (!text) return emptyValue;

  let normalized = Array.isArray(text)
    ? text.filter(Boolean).join(joinWith)
    : text;

  if (!normalized) return null;

  if (replacePattern) {
    normalized = normalized.replace(replacePattern, replaceValue);
  }

  const normalizedFormatted = titleCase(t(normalized).toLowerCase());

  return <span title={normalizedFormatted}>{normalizedFormatted}</span>;
};
